import PropTypes from "prop-types";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Button, Divider, IconButton, Typography } from "@mui/material";

const PageHeader = ({ title, btn, subTitle, rightSection, btn2 }) => {
  return (
    <Box sx={{ mb: 2 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          py: 1.25,
          px: 0,
          pt: 0,
          minHeight: 48,
          // backgroundColor: "red",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          {btn?.back && (
            <IconButton size="small" onClick={btn.back} sx={{ mr: 0.5 }}>
              <ArrowBackIcon fontSize="small" />
            </IconButton>
          )}
          <Box>
            <Typography variant="h6" fontWeight={700} lineHeight={1.2}>
              {title}
            </Typography>
            {subTitle && (
              <Typography variant="caption" color="text.secondary">
                {subTitle}
              </Typography>
            )}
          </Box>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          {rightSection && <Box>{rightSection}</Box>}
          {btn2?.show && (
            <Button variant={btn2.type} onClick={btn2.callBack} size="small">
              {btn2.text}
            </Button>
          )}
          {btn?.show && (
            <Button variant={btn.type} onClick={btn.callBack} size="small">
              {btn.text}
            </Button>
          )}
        </Box>
      </Box>
      <Divider />
    </Box>
  );
};

PageHeader.defaultProps = {
  btn: {},
};

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  btn: PropTypes.object,
  btn2: PropTypes.object,
};

export default PageHeader;
